import angular from 'angular';
import { emailPostClicksComponent } from './emailPostClicksComponent';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/image/loaded/imageLoadedModule';
import 'components/sharpr/post/history/postHistoryModule';
import 'components/sharpr/percentRounding/percentRoundingModule';
import 'components/sharpr/date/dateFormat/dateFormatModule';

angular
	.module('sh.emailPostClicks', ['sh.api', 'sh.imageLoaded', 'sh.postHistory', 'sh.percentRounding', 'sh.dateFormat'])
	.component('shEmailPostClicks', emailPostClicksComponent());
